module.exports = __webpack_public_path__ + "img/AboutUs_picture_6.fb7c7b4d.jpg";